import './MarketStatisticsDetail.less';

import React, { useContext } from 'react';
import ArrowDiagonalIcon from '../../../icons/ArrowDiagonalIcon';
import clsx from 'clsx';
import MarketStatisticsDropdown from './MarketStatisticsDropdown';
import SportEventContext from '../../../common/SportEventContext';
import BetLocationContext from '../../../common/BetLocationContext';
import i18n from '../../../common/i18n';
import { useReframe } from 'nike-re-framejs';
import { getBetStateFromTlv$, getOddsFromTlv$$ } from '../reframe/h&s';

function getOddsStatus(initialOdds, odds) {
    if (odds > initialOdds) {
        return 'rising';
    }
    if (odds < initialOdds) {
        return 'falling';
    } else return 'equal';
}
function ProgressBar({ percentage, position }) {
    return (
        <div className="statistics-progressbar">
            <div className={clsx('fill', position === 1 ? 'first' : 'other')} style={{ width: percentage + '%' }} />
        </div>
    );
}

export function MarketStatisticsBox({ stats, betId, infoNumber, isSelected, addPick, live }) {
    const { subscribe } = useReframe();
    const selectionName = stats.get('selectionName');
    const selection = stats.get('selection');
    const odds = live ? subscribe(getOddsFromTlv$$(betId.toString(), selection)) : stats.get('odds');
    const initialOdds = stats.get('initialOdds');
    const stakeShare = stats.get('stakeShare');
    const ticketsShare = stats.get('ticketsShare');
    const stakeShareOrderDesc = stats.get('stakeShareOrderDesc');
    const enabled = live ? subscribe(getBetStateFromTlv$(betId)) : stats.get('enabled');
    const oddsStatus = getOddsStatus(initialOdds, odds);
    const betLocationContext = useContext(BetLocationContext);
    const pick = {
        betId: betId,
        selectionCode: selection,
        odds: odds,
        infoNumber: infoNumber,
        sourceOrigin: 'MarketStatistics',
        positionId: betLocationContext.betLocationSection?.id,
        positionCode: betLocationContext.betLocationSection?.code
    };
    return (
        <div
            className={clsx('nui-marketing-statistics-selection', {
                'disabled bg-white nui-marketing-statistics-selection-disabled': !enabled
            })}
            data-selection-name={selectionName}
        >
            <div className="information">
                <span className="text-extra-bold">{selectionName}</span>
                <div className="bet-status">
                    <span className="first-bet">
                        {initialOdds != null && initialOdds?.toFixed(2)}
                        <div className={oddsStatus}>
                            {initialOdds != null && oddsStatus !== 'equal' ? <ArrowDiagonalIcon /> : null}
                        </div>
                    </span>
                    <button
                        className={clsx('last-bet', {
                            selected: isSelected(betId, selection, live),
                            disabled: !enabled
                        })}
                        onClick={() => enabled && addPick(pick)}
                        data-atid="market-statistics-bet-button"
                    >
                        {odds?.toFixed(2)}
                    </button>
                </div>
            </div>
            <ProgressBar percentage={stakeShare} position={stakeShareOrderDesc} />
            <div className="bets-percentages">
                <span className="percentage-value">
                    {stakeShare} %<span className="value-type">{i18n('nui.MS.bets')}</span>
                </span>
                <span className="percentage-value">
                    {ticketsShare} %<span className="value-type">{i18n('nui.MS.tickets')}</span>
                </span>
            </div>
        </div>
    );
}

export const trackingDataForMarketStatisticsEvent = sportEvent => {
    if (!sportEvent) {
        return;
    }

    const sport = sportEvent.get('sport');
    const tournament = sportEvent.get('tournamentName');
    const participants =
        sportEvent.get('participants')?.toJS() ||
        [sportEvent.getIn(['opponents', 'home']), sportEvent.getIn(['opponents', 'away'])].filter(Boolean).join(' - ');
    const matchId = sportEvent.get('id');
    const gameState = sportEvent.get('isLive') ? 'LIVE' : 'PREMATCH';
    return {
        'data-sport': sport,
        'data-tournament': tournament,
        'data-participants': participants,
        'data-match-id': matchId,
        'data-game-state': gameState
    };
};

function MarketStatisticsDetail({ stats, isSelected, addPick, oddColored, live }) {
    const betId = stats.get('betId');
    const selections = stats.get('selections');
    const infoNumber = stats.get('infoNumber');
    const sportEvent = useContext(SportEventContext);

    return (
        <div
            className={clsx('nui-marketing-statistics', { oddColored })}
            data-market-name={stats.get('betHeaderDetail')}
            data-market-id={stats.get('marketId')}
            data-game-state={!live ? 'PREMATCH' : 'LIVE'}
            {...trackingDataForMarketStatisticsEvent(sportEvent)}
        >
            {selections.size > 6 ? (
                <MarketStatisticsDropdown stats={stats} isSelected={isSelected} addPick={addPick} live={live} />
            ) : (
                selections.map(selection => (
                    <MarketStatisticsBox
                        key={selection.get('selectionName')}
                        stats={selection}
                        betId={betId}
                        infoNumber={infoNumber}
                        isSelected={isSelected}
                        addPick={addPick}
                        live={live}
                    />
                ))
            )}
        </div>
    );
}
export default MarketStatisticsDetail;
